function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/utils/validate';
import { mapState } from 'vuex';
export default {
  name: 'home_timerange',
  cname: '时间范围',
  icon: 'icon-biaodanzujian-shijianfanwei',
  configName: 'c_home_timerange',
  type: 0,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'timeranges',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread({}, mapState('mobildConfig', ['defaultArray'])),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        name: 'timeranges',
        timestamp: this.num,
        titleConfig: {
          title: '标题',
          val: '时间范围',
          place: '请输入标题',
          max: 10,
          type: 'form',
          isShow: 1
        },
        valConfig: {
          title: '默认值',
          type: 'timerange',
          specifyDate: '',
          tabVal: 0,
          tabData: 0,
          tabList: [{
            name: '显示'
          }, {
            name: '隐藏'
          }],
          dataList: [{
            name: '当前时间'
          }, {
            name: '指定时间'
          }]
        },
        tipConfig: {
          title: '提示语',
          val: '请选择',
          place: '请输入提示语',
          max: 10,
          type: 'form',
          isShow: 1
        },
        titleShow: {
          title: '是否必填',
          val: true,
          type: 'form'
        }
      },
      titleTxt: '',
      tipVal: '',
      pageData: {},
      time: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
      _this.setConfig(_this.pageData);
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data.titleConfig) {
        this.titleTxt = data.titleConfig.val;
        if (data.valConfig.tabVal == 0) {
          if (data.valConfig.tabData == 0) {
            this.tipVal = '';
            var now = new Date();
            var hours = now.getHours(); // 得到时间
            var minutes = now.getMinutes() >= 10 ? now.getMinutes() : '0' + now.getMinutes(); // 得到分钟
            hours = hours.toString().padStart(2, '0');
            var current = "".concat(hours, ":").concat(minutes);
            this.time = current;
            this.time = current + ' - ' + current;
          } else {
            if (data.valConfig.specifyDate[0]) {
              this.tipVal = '';
              this.time = data.valConfig.specifyDate[0] + ' - ' + data.valConfig.specifyDate[1];
            } else {
              this.tipVal = data.tipConfig.val;
            }
          }
        } else {
          this.tipVal = data.tipConfig.val;
        }
      }
    }
  }
};